
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { TrendingUp, AlertTriangle, Activity, Wrench, BarChart } from 'lucide-react';
import BikeRevenueTable from './bike-revenue/BikeRevenueTable';
import TimeRevenueChart from './bike-revenue/TimeRevenueChart';
import ModelRevenueChart from './bike-revenue/ModelRevenueChart';
import PaybackMetricsCard from './bike-revenue/PaybackMetricsCard';
import BikeRevenueFilters from './bike-revenue/BikeRevenueFilters';
import ViewTypeSelector from './bike-revenue/ViewTypeSelector';
import { BikeMaintenanceAnalytics } from './BikeMaintenanceAnalytics';
import { BikeMovementMonitoring } from './BikeMovementMonitoring';
import { BikeDowntimeAnalytics } from './BikeDowntimeAnalytics';
import { useBikeRevenueData } from './bike-revenue/useBikeRevenueData';

const BikeAnalytics: React.FC = () => {
  const {
    date,
    setDate,
    selectedModel,
    setSelectedModel,
    availableModels,
    loading,
    viewType,
    setViewType,
    filteredData,
    modelChartData,
    timeChartData,
    exportToCSV,
    dateRangeText,
    targetRevenue
  } = useBikeRevenueData();

  // Подсчет статистики для использования
  const totalBikes = filteredData.length;
  const usedBikes = filteredData.filter(bike => bike.rentalCount > 0).length;

  return (
    <div className="space-y-6">
      <Tabs defaultValue="revenue" className="space-y-4">
        <TabsList className="grid w-full grid-cols-5">
          <TabsTrigger value="revenue" className="flex items-center gap-2">
            <TrendingUp className="h-4 w-4" />
            Выручка
          </TabsTrigger>
          <TabsTrigger value="models" className="flex items-center gap-2">
            <BarChart className="h-4 w-4" />
            Модели
          </TabsTrigger>
          <TabsTrigger value="downtime" className="flex items-center gap-2">
            <Activity className="h-4 w-4" />
            Простои
          </TabsTrigger>
          <TabsTrigger value="movement" className="flex items-center gap-2">
            <AlertTriangle className="h-4 w-4" />
            Движение
          </TabsTrigger>
          <TabsTrigger value="maintenance" className="flex items-center gap-2">
            <Wrench className="h-4 w-4" />
            Обслуживание
          </TabsTrigger>
        </TabsList>

        <TabsContent value="revenue" className="space-y-4">
          <BikeRevenueFilters
            date={date}
            setDate={setDate}
            selectedModel={selectedModel}
            setSelectedModel={setSelectedModel}
            availableModels={availableModels}
            onExport={exportToCSV}
            loading={loading}
          />

          <PaybackMetricsCard 
            data={filteredData} 
            targetRevenue={targetRevenue}
          />

          <BikeRevenueTable
            data={filteredData}
            loading={loading}
            dateRangeText={dateRangeText}
            targetRevenue={targetRevenue}
          />
        </TabsContent>

        <TabsContent value="models" className="space-y-4">
          <BikeRevenueFilters
            date={date}
            setDate={setDate}
            selectedModel={selectedModel}
            setSelectedModel={setSelectedModel}
            availableModels={availableModels}
            onExport={exportToCSV}
            loading={loading}
          />

          <ModelRevenueChart
            data={modelChartData}
            loading={loading}
            dateRangeText={dateRangeText}
            targetRevenue={targetRevenue}
          />
        </TabsContent>

        <TabsContent value="downtime" className="space-y-4">
          <BikeDowntimeAnalytics />
        </TabsContent>

        <TabsContent value="movement" className="space-y-4">
          <BikeMovementMonitoring />
        </TabsContent>

        <TabsContent value="maintenance" className="space-y-4">
          <BikeMaintenanceAnalytics />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default BikeAnalytics;
